import { defineStore, acceptHMRUpdate } from 'pinia'

export const usePageStore = defineStore('page', () => {
  const isPageLoading = ref(false)
  const setPageLoading = (loading: boolean) => {
    isPageLoading.value = loading
  }

  return { isPageLoading, setPageLoading }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePageStore, import.meta.hot))
}
